import React, {
  useMemo,
  useContext,
  createContext,
  forwardRef,
} from 'react';
import {
  Flex,
  useCheckboxGroup,
} from '@chakra-ui/react';
import { Base } from '../Base';

const ButtonCheckboxGroupContext = createContext({});

export const useButtonCheckboxGroup = () => useContext(ButtonCheckboxGroupContext);

export const ButtonCheckboxGroup = forwardRef(({
  name,
  error,
  onBlur,
  children,
  onChange,
  isDisabled,
  value: valueProp,
  innerContentProps,
  ...props
}, ref) => {
  const {
    getCheckboxProps,
  } = useCheckboxGroup({
    ref,
    name,
    onBlur,
    onChange,
    isDisabled,
    value: valueProp,
  });

  const value = useMemo(() => ({
    error,
    getCheckboxProps,
  }), [
    error,
    getCheckboxProps,
  ]);

  return (
    <Base {...props} error={error}>
      <ButtonCheckboxGroupContext.Provider value={value}>
        <Flex gap="2" wrap="wrap" {...innerContentProps}>
          {children}
        </Flex>
      </ButtonCheckboxGroupContext.Provider>
    </Base>
  );
});
